export enum LearnerFilter {
  All = 'all',
  HaventStarted = 'haventStarted',
  HaventCompleted = 'haventCompleted',
  Completed = 'completed',
}
